import React from "react"
import Ionicon from 'react-ionicons'
import { Star, ChevronLeft, Search } from "react-feather"
import { Form, CellBody } from "react-weui"
  
import AddressInput from './AddressInput'


export default class SearchOrigin extends React.PureComponent {
  render() {
    return (
      <div className="searchAux">
      
      
        <div checkbox className="search-container" >
          <div checkbox className="field" >
            <div className="white">
              <div
                className="icon back"
                onClick={() => this.props.goBack()}
              >
                <ChevronLeft />
              </div>
              <AddressInput
                value={this.props.customOriginAddress || ""}
                city={this.props.city}
                placeholder='Busca su origen'
                changeAddress={(newValue, method) => this.props.changeAddress(newValue, method)}
                changeCoords={(geoLocation, city) => this.props.changeCoords(geoLocation, city)}
              />
              { /* #TODO clear the field */ }
              <div className="icon search">
                <Search />
              </div>
            </div>
          </div>
      
          <div className="search-recommendations">
            <div
              className="row"
              onClick={e => {
                e.stopPropagation();
                this.props.setGeo()
                this.props.push(`/catalogo/${this.props.city}/transportation?step=showOrigin`)
              }}
            >
              <div className="left"><Ionicon fontSize="4vh" icon="md-locate" color="#6692e2"/></div>
              <div className="right">位置</div>
            </div>
          </div>
      
        </div>
      
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/SearchOrigin.jsx